<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="100px" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="value8">
          <el-select v-model="form.sysId" clearable filterable placeholder="请选择业务系统">
            <el-option
              v-for="item in sysData"
              :key="item.systemId"
              :label="item.systemName"
              :value="item.systemId" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名称" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="userName">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <!-- <el-table-column label="用户头像">
          <template >
            <img src="../../../assets/default.png" width="50" height="50">
          </template>
        </el-table-column>
        <el-table-column
          label="用户昵称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.nickName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.userRealName }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号码"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="密码"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.password }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="E-mail"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="注册时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column width="190" fixed="right" label="操作" >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.locked"
              active-value="0"
              inactive-value="1"
              @change="changeStatus(scope.$index, scope.row)">
            </el-switch>
            <el-button style="margin-left: 10px;" size="mini"  @click="detail(scope.$index, scope.row)">用户轨迹</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog title="供应商充值详情" width="850px" center :modal-append-to-body='false' :visible.sync="cusDialog">
      <el-form :model="detailForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supName" ></el-input>
              <!-- <span>{{detailForm.supName}}</span> -->
            </el-form-item>
            <el-form-item label="账号名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supAccountName" ></el-input>
              <!-- <span>{{detailForm.supAccountName}}</span> -->
            </el-form-item>
            <el-form-item label="账号:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supAccountId" ></el-input>
              <!-- <span>{{detailForm.supAccountId}}</span> -->
            </el-form-item>
            <el-form-item label="充值金额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeAmount" ></el-input>
              <!-- <span>{{detailForm.rechargeAmount}}</span> -->
            </el-form-item>
            <el-form-item label="充值后余额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeBalance" ></el-input>
              <!-- <span>{{detailForm.rechargeBalance}}</span> -->
            </el-form-item>
            <el-form-item label="累计充值金额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeAmountTotal" ></el-input>
              <!-- <span>{{detailForm.rechargeAmountTotal}}</span> -->
            </el-form-item>
            <el-form-item label="支付说明:" >
              <span>{{detailForm.rechargeDesc }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.operator" ></el-input>
              <!-- <span>{{detailForm.operator}}</span> -->
            </el-form-item>
            <el-form-item label="充值时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.createTime" ></el-input>
              <!-- <span>{{detailForm.createTime}}</span> -->
            </el-form-item>
            <el-form-item label="充值类型:" >
              <span>{{detailForm.rechargeType === '1' ? '补偿款' : '预充值' }}</span>
            </el-form-item>
            <el-form-item label="是否包年:" >
              <span>{{detailForm.yearFlag === '1' ? '是' : '否' }}</span>
            </el-form-item>
            <el-form-item label="支付方式:" >
              <span>{{detailForm.payMethod === '1' ? '网银转账' : '垫付' }}</span>
            </el-form-item>
            <el-form-item label="充值凭证:" >
              <img class="img" :src="detailForm.rechargeProof" alt="">
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'registeredUser',
  data () {
    return {
      form: {
        userName: '',
        phone: '',
        sysId: '',
        email: ''
      },
      cusDialog: false,
      tableData: [],
      detailForm: {},
      tooltip: true,
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.userName = ''
      this.form.phone = ''
      this.form.sysId = ''
      this.form.email = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    changeStatus (index, value) {
      console.log(value)
      if (value.locked === '1') {
        value.locked = '0'
        let params = {
          userId: value.userId,
          locked: 1
        }
        this.$confirm('确认是否修改用户状态为锁定?', '锁定', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(_self.$API.rechargeManagement.modifyUserLockedByUserId, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '锁定成功'
                })
                _self.query()
              })
              .catch(function (error) { console.log(error) })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.locked = '1'
        let params = {
          userId: value.userId,
          locked: 0
        }
        this.$confirm('确认是否修改用户状态为启用?', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(_self.$API.rechargeManagement.modifyUserLockedByUserId, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '启用成功'
                })
                _self.query()
              })
              .catch(function (error) { console.log(error) })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    detail (index, val) {
      this.$router.push({
        name: 'userJournal',
        query: {
          id: val.userId,
          sysId: val.sysId
        }
      })
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.userRealName = this.form.userName
      op.mobile = this.form.phone
      op.email = this.form.email
      op.sysIds = sysIds
      this.$axios({
        url: _this.$API.rechargeManagement.queryRegistUserByPage,
        // url: 'http://172.16.9.148:5010/agw/cucu/user/queryRegistUserByPage',
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userManagement/registeredUser.vue